export const formatAddress = address => {
  if (!address) return '';

  const street = [address.streetName, address.houseNumber, address.houseNumberAdditional].filter(Boolean).join(' ');

  const place = [address.postalCode, address.settlementName].filter(Boolean).join(' ');

  const parts = [street, place, address.county, address.stateName].filter(Boolean);

  return parts.join(', ');
};
